import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import useSession from '../hooks/useSession';

// Route-level authorization, centralizing the guard the pages used to each do
// themselves. `requires`:
//   'auth'   — any signed-in user
//   'member' — signed-in member/admin (has the member claim)
// Signed-out visitors go to /login (returning here after they authenticate);
// signed-in users who lack the required claim are sent home.
export default function ProtectedRoute({ requires = 'auth', children }) {
  const { loading, user, hasMember } = useSession();
  const location = useLocation();

  if (loading) return null; // resolving the session; avoids a flash of the page
  if (!user) {
    const next = encodeURIComponent(location.pathname + location.search);
    return <Navigate to={`/login?next=${next}`} replace />;
  }
  if (requires === 'member' && !hasMember) return <Navigate to="/" replace />;
  return children;
}
